import { Link } from "react-router-dom";
import { Text } from "@nbs/ui";

export type InsightItem = {
  id: string;
  label: string;
  severity: string;
  algorithmOrQuery: string;
  sourceMesureIds: string[];
};

export type InsightListProps = {
  readonly insights: readonly InsightItem[];
  readonly loading?: boolean;
  readonly emptyMessage?: string;
  readonly headingId?: string;
  readonly title?: string;
};

export function InsightList({
  insights,
  loading,
  emptyMessage = "Aucun insight dérivé disponible.",
  headingId = "insights-heading",
  title = "Insights et alertes",
}: InsightListProps) {
  return (
    <section className="nbs-insights-panel" aria-labelledby={headingId}>
      <h3 id={headingId}>{title}</h3>
      <ul className="nbs-insights-list">
        {insights.map((insight) => (
          <li key={insight.id} className={`nbs-insight nbs-insight--${insight.severity}`}>
            <strong>{insight.label}</strong>
            <Text tone="muted">{insight.algorithmOrQuery}</Text>
            {insight.sourceMesureIds[0] ? (
              <Link to={`/n3?mesureIds=${insight.sourceMesureIds.join(",")}`}>Mesures sources</Link>
            ) : null}
          </li>
        ))}
        {!loading && insights.length === 0 ? (
          <li>
            <Text>{emptyMessage}</Text>
          </li>
        ) : null}
      </ul>
    </section>
  );
}
